import { CIcon } from '~/icons/types'

export const ciSupermarket: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21 8.457h-1.734L16.8 3.515a.502.502 0 0 0-.9.447l2.248 4.5H5.852l2.248-4.5a.5.5 0 1 0-.895-.447L4.734 8.457H3a1.5 1.5 0 0 0-1.5 1.5v.61a1.5 1.5 0 0 0 1.393 1.488L4.3 19.08a2.21 2.21 0 0 0 2.126 1.68h11.062a2.24 2.24 0 0 0 2.219-1.7l1.4-7a1.5 1.5 0 0 0 1.393-1.493v-.609a1.5 1.5 0 0 0-1.5-1.5Zm-2.27 10.385a1.227 1.227 0 0 1-1.225.916H6.479a1.172 1.172 0 0 1-1.207-.9l-1.357-6.8h16.17l-1.355 6.784Zm2.77-8.276a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-.609a.5.5 0 0 1 .5-.5h18a.5.5 0 0 1 .5.5v.61Z'
    },
    {
      d:
        'M12 17.718a.5.5 0 0 0 .5-.5v-3.044a.5.5 0 0 0-1 0v3.044a.5.5 0 0 0 .5.5Zm3.93-.006a.56.56 0 0 0 .071 0 .5.5 0 0 0 .494-.43l.435-3.044a.5.5 0 1 0-.991-.14l-.434 3.044a.5.5 0 0 0 .425.57Zm-7.844.004a.56.56 0 0 0 .071 0 .5.5 0 0 0 .425-.565L8.147 14.1a.506.506 0 0 0-.565-.425.5.5 0 0 0-.425.565l.435 3.044a.5.5 0 0 0 .494.433Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'supermarket',
  type: 'thin'
}
